import { AxiosError } from 'axios';
import { GET_FILE_BULK_PROCESSING_STATUS_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import { GET_FILE_BULK_PROCESSING_STATUS_URL } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface FileProcessingStatusResponse {
  errorMessage?: string;
  status: string;
  numberOfRecords?: number;
  presignUrl?: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  enabled?: boolean;
  onSuccess?: (data: FileProcessingStatusResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  fileKey: string;
  refetchInterval: number | undefined;
}

export const useGetFileProcessingStatus = ({
  fileKey,
  refetchInterval,
  enabled = false,
  onSuccess,
  onError,
}: Input) => {
  const getFileProcessingStatus = async () => {
    const res = await axiosClient.get<FileProcessingStatusResponse>(
      GET_FILE_BULK_PROCESSING_STATUS_URL(fileKey)
    );
    return res.data;
  };

  return useCustomQuery(
    [GET_FILE_BULK_PROCESSING_STATUS_QUERY_KEY, fileKey],
    getFileProcessingStatus,
    {
      onSuccess,
      onError,
      retryOnMount: true,
      refetchOnWindowFocus: true,
      cacheTime: 0,
      refetchInterval,
      enabled,
    }
  );
};
